import { isOpenInApp } from "@repo/shared-utils/pwa-utils";

declare const window: {
  clevertap: any;
} & Window;

export const clevertapEvent = (event: string, eventData: Record<string, string>): void => {
  const filteredEventData = Object.fromEntries(
    Object.entries(eventData).filter(([_, value]) => value !== "NA")
  );

  if (isOpenInApp()) {
    window.prompt(
      `triggerCTEvent://${JSON.stringify({ eventName: event, props: filteredEventData })}`
    );
    return;
  }

  if (window.clevertap) {
    if (window.clevertap.getAccountID) {
      window.clevertap.event.push(event, filteredEventData);
    } else {
      setTimeout(() => {
        window.clevertap.event.push(event, filteredEventData);
      }, 1500);
    }
  }
};
